import React, {Component} from "react"
import {capitalize} from "lodash"
import {connect} from "react-redux"

import {User} from "~/utils/ShelfEntities"
import {
  ApiForm,
  FormSection,
  Field,
  BooleanField,
  TitleSection
} from "~/components/"

import {withTranslation} from "react-i18next"

class UserForm extends Component {
  render() {
    const hiddenValues = {subdomain: this.props.tenant}

    return (
      <ApiForm
        for={User}
        then={this.props.then}
        id={this.props.id}
        submitLabel={this.props.t("users.form.submit")}
        hiddenValues={hiddenValues}
      >
        <TitleSection>
          <h3>
            {this.props.id
              ? this.props.t("users.form.editTitle")
              : this.props.t("users.form.createTitle", {
                  tenant: capitalize(this.props.tenant)
                })}
          </h3>
        </TitleSection>
        <FormSection>
          <Field
            label={this.props.t("users.form.email")}
            type="email"
            name="email"
          />
          <Field
            label={this.props.t("users.form.password")}
            type="password"
            name="password"
          />
        </FormSection>
        <FormSection label={this.props.t("users.form.roles")}>
          <BooleanField
            name="admin"
            disabled={!this.props.superAdmin && !this.props.admin}
          >
            {this.props.t("users.form.isAdmin")}
          </BooleanField>
          <BooleanField
            name="tenant_admin"
            disabled={!this.props.superAdmin && !this.props.admin}
          >
            {this.props.t("users.form.isTenantAdmin")}
          </BooleanField>
        </FormSection>
        <FormSection label={this.props.t("users.form.settings")}>
          <BooleanField label="" name="may_use_cart">
            {this.props.t("users.form.mayUseCart")}
          </BooleanField>
        </FormSection>
      </ApiForm>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {admin, tenantAdmin, superAdmin} = user
  return {
    admin,
    tenantAdmin,
    superAdmin
  }
}

export default withTranslation()(connect(mapStateToProps)(UserForm))



// WEBPACK FOOTER //
// ./src/components/forms/UserForm.js